import PrivatePersonOrBusinessFields from "./PrivatePersonOrBusinessFields";

export default PrivatePersonOrBusinessFields;
